import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteLogo, updateBranding } from '../api/settingsApi';

// Settings mutations are not driven by SignalR, so the mutation hooks own
// cache invalidation here.

export function useUpdateBranding() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => updateBranding(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['companyBranding'] });
        },
    });
}

export function useDeleteLogo() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => deleteLogo(),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['companyBranding'] });
        },
    });
}
